/**
 * RentPublishAlert
 * 
 * @Author: Focci
 * @Date: 2023-12-25 13:31:56
 * @Last Modified by: Focci
 * @Last Modified time: 2023-12-25 13:31:56
 */

'use client'

import PropTypes from 'prop-types'
import useLogin from '@hook/useLogin'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import Link from 'next/link'
import { editPublish } from '@lib/route/profile'
import { useLocale, useTranslations } from 'next-intl'

export default function RentPublishAlert({
  houseId
}) {
  const locale = useLocale()
  const tp = useTranslations('profile')
  const { isLogin } = useLogin()

  if(!isLogin) {
    return null
  }

  return (
    <Link href={editPublish(houseId, locale)}>
      <div 
        className="
          flex items-center gap-x-1
          text-red-500 bg-red-50 border border-red-300 px-2 py-1 rounded-md
        "
      >
        <span>{tp('propertyIsDraft')}</span>
        <ArrowForwardIosIcon sx={{ fontSize: '.7rem' }} />
        {/* {houseId} */}
      </div>
    </Link>
  )
}

RentPublishAlert.propTypes = {
  houseId: PropTypes.number,
}
